module.exports = __webpack_public_path__ + "static/media/02.eb45b711.gif";